import React from 'react'
import { StylesObj, StyleKey, defaultStyles } from '../Styles/index'

const StyledComponent: React.FC<StyledComponentProps> = ({
  styles = defaultStyles,
  children,
}) => {
  const getStyles: GetStylesType = (key, state): {} => {
    const base = defaultStyles[key](state)
    base.boxSizing = 'border-box'
    const custom = styles[key]
    return custom ? custom(base, state) : base
  }
  if (children) {
    return typeof children === 'function' ? children({ getStyles }) : children
  }
  return null
}

type StyledComponentProps = {
  styles?: StylesObj
}

export type GetStylesType = (key: StyleKey, state: {}) => {}

export default StyledComponent
